import AddNewProduct from "./AddNewProduct";
export default AddNewProduct